import { render, staticRenderFns } from "./HeaderPrice.vue?vue&type=template&id=bc64ad2c&"
import script from "./HeaderPrice.vue?vue&type=script&lang=js&"
export * from "./HeaderPrice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports